import Homecontent from "./data/homecontent";
import { Topheader } from "./common/topheader";
import astro from "./images/services/kundali.jpg";
import { Innerbanner } from "./common/innerbanner";
import {Footer} from './common/footer';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhoneSquare } from "@fortawesome/free-solid-svg-icons";
function Kundalianalis(props2){


    return(
<div>
<Topheader></Topheader>
<Innerbanner title={"Kundali Analysis"}></Innerbanner>

<div className="container-fluid">

    <div className="container">
<div className="d-flex flex-column flex-sm-row flex-lg-row flex-md-row">

    <div className="bg-light shadow p-3 m-3 flex-fill"><img  src={astro } alt="famous astrologer Gurgaon" className="img-fluid float-start m-3"></img>
   <p> 
   A Kundali (also known as a Janam Kundli or birth chart) is essentially a snapshot of the sky at the exact moment of your birth. It maps the positions of celestial bodies like planets and constellations, along with other astrological elements which help astrologers understand the potential influences on your life

   </p>
    
<p>
<span className="fw-bolder">Horoscope Reading & Analysis: </span> Detailed analysis using your birth details to interpret your personality, strengths, and challenges. This can provide guidance on suitable career paths, relationship insights, and overall life direction2.
</p><p>
<span className="fw-bolder">Matchmaking:</span>  A detailed comparison of two horoscopes to assess compatibility for marriage or long-term partnerships. Factors such as Guna Milan, Manglik Dosha, and other planetary influences are considered.
</p><p>
<span className="fw-bolder">Career Guidance:</span>  Analysis of the tenth house and other related aspects of the Kundali to provide advice on career choices, job changes, business prospects, and opportunities.
</p><p>
<span className="fw-bolder">Health Predictions:</span>  Using the sixth house and related planetary positions to predict potential health challenges and provide remedies.
</p><p>
<span className="fw-bolder">Wealth and Financial Reports:</span>  Analysis targeting the second house and other relevant aspects to offer insights into finances, wealth accumulation, and investments
</p><p>
<span className="fw-bolder">Dasha Predictions: </span> Dasha Predictions: Detailed predictions based on the Mahadasha and Antardasha influences, which are the periods dominated by particular planets according to Vedic astrology.
</p><p>
<span className="fw-bolder">Customized Remedies and Solutions:</span>  Based on the Kundali analysis, astrologers provide specific solutions like mantra chanting, wearing gemstones, performing rituals, or changes in lifestyle to alleviate negative planetary influences.
</p>
<p className="text-center"><a href='https://api.whatsapp.com/send?phone=919873336259&text='><button className="btn btn-danger">Book an Appoitment to Consult </button></a></p>
    </div>


</div>


    </div>



</div>
<Footer></Footer>









</div>






 );







    
}
export { Kundalianalis} ;